import { render, staticRenderFns } from "./DataListTableTmpl.vue?vue&type=template&id=5b7ed36e&scoped=true&"
import script from "./DataListTableTmpl.vue?vue&type=script&lang=js&"
export * from "./DataListTableTmpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7ed36e",
  null
  
)

export default component.exports